import { ReadonlyURLSearchParams } from 'next/navigation';

/**
 * Convert URLSearchParams to query object
 * @example searchParamsToQuery(new URLSearchParams('a=1&b=2&b=3'))
 * @param searchParams ReadonlyURLSearchParams
 * @returns object
 */
export const searchParamsToQuery = (
  searchParams: ReadonlyURLSearchParams
): { [key: string]: string | string[] } => {
  const query: { [key: string]: string | string[] } = {};

  searchParams.forEach((value, key) => {
    if (query[key]) {
      if (Array.isArray(query[key])) {
        (query[key] as string[]).push(value);
      } else {
        query[key] = [query[key] as string, value];
      }
    } else {
      query[key] = value;
    }
  });

  return query;
};
